<template>
  <div class="basic-data">
    <div class="basic-data-content cursor-default">
      <div class="text-center basic-data-title text-center">基础资料</div>
      <ul class="text-left basic-data-list w-1/2">
        <li class="clearfix head-portrait">
          <span class="inline-block w-1/3"
            ><i class="s-circular"></i>我的头像</span
          >
          <span class="inline-block w-2/3">
            <img
              v-if="formData.avatar_url.value"
              class="inline-block head-img"
              :src="formData.avatar_url.value"
              alt="head"
            />
            <img
              v-else
              class="inline-block head-img"
              src="../../../../static/images/public/head-img.png"
              alt="head"
            />
          </span>
        </li>
        <li class="clearfix">
          <span class="inline-block w-1/3"
            ><i class="s-circular"></i>我的昵称</span
          >
          <span class="w-2/3 inline-block">{{ formData.username.value }}</span>
        </li>
        <li class="clearfix">
          <span class="inline-block w-1/3"
            ><i class="s-circular"></i>我的手机号</span
          >
          <span class="w-2/3 inline-block">
            <span
              v-if="formData.oldTel.value && formData.oldTel.value !== ''"
              class="pr-12"
              >{{ formData.oldTel.value }}</span
            >
            <span class="inline-block cursor-pointer" @click="bindTel"
              >[
              {{
                formData.oldTel.value && formData.oldTel.value !== ''
                  ? '点击修改'
                  : '点击绑定'
              }}
              ]</span
            >
          </span>
        </li>
        <li class="inline-block privacy w-full">
          <span class="inline-block"><i class="s-circular"></i>阅读</span>
          <span
            class="privacy-title cursor-pointer"
            @click="showAgreement = true"
            >《会员协议》</span
          >
          <span class="privacy-p"> 、</span>
          <span class="privacy-title cursor-pointer" @click="showPrivacy = true"
            >《隐私政策》</span
          >
        </li>
      </ul>
    </div>
    <PrivacyBar :show.sync="showPrivacy"></PrivacyBar>
    <Masker :show.sync="showPrivacy"></Masker>
    <AgreementBar :show.sync="showAgreement"></AgreementBar>
    <Masker :show.sync="showAgreement"></Masker>
    <ReplaceMobile
      v-if="showModal"
      :show.sync="showModal"
      :formData="formData"
    ></ReplaceMobile>
    <Masker :show.sync="showModal"></Masker>
  </div>
</template>

<script>
import link from '@/core/mixins/link'
import valid from '@/core/mixins/valid'
import ReplaceMobile from '@/components/common/ReplaceMobile'
import Masker from '@/components/common/Mask'
import EventBus from '@/core/eventbus'
import PrivacyBar from '@/components/common/PrivacyBar'
import AgreementBar from '@/components/common/AgreementBar'
// import Breadcrumb from '@/components/common/Breadcrumb'

export default {
  name: 'basic-data',
  mixins: [link, valid],
  components: {
    Masker,
    // Breadcrumb,
    ReplaceMobile,
    PrivacyBar,
    AgreementBar
  },
  data() {
    return {
      formData: {
        avatar_url: { value: '', error: '' },
        username: { value: '', error: '' },
        oldTel: { value: '', error: '' },
        verifyCode: { value: '', error: '' }
      },
      showModal: false,
      showPrivacy: false,
      showAgreement: false
      // code: '发送验证码'
    }
  },
  computed: {
    client() {
      let data = this.$store.getters['SubscriberStore/client']
      return data
    },
    isLogin() {
      let subscriber = this.$store.getters['SubscriberStore/subscriber']
      let client = this.$store.getters['SubscriberStore/client']
      return subscriber && client && subscriber.open_id && client.mobile
    }
  },
  watch: {
    client() {
      this.getClient()
    }
  },
  mounted: function() {
    this.getClient()
  },
  methods: {
    bindTel() {
      if (this.isLogin) {
        this.formData.oldTel.value && this.formData.oldTel.value !== ''
        this.showModal = true
      } else {
        EventBus.$emit('showModal')
      }
    },
    // tab栏切换
    tabFn(value) {
      this.tab = value
    },
    getClient() {
      if (!this.client) {
        return
      }
      this.formData.avatar_url.value = this.client.avatar_url
      this.formData.username.value = this.client.nickname
      this.formData.oldTel.value = this.client.mobile
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.basic-data {
  // height: 380px;
  margin-top: 60px;
  margin-bottom: 50px;
  background-color: $c-tour-bg-blue;
  background-image: url('../../../../static/images/tour/bg-flower-b.png');
  background-repeat: no-repeat;
  background-size: auto 580px;
  background-position: 750px -20px;
  padding: 40px 52px;
  .basic-data-title {
    width: 170px;
    height: 26px;
    font-size: 24px;
    color: $c-white;

    background-position: center;
    background-size: auto 0;
    background-repeat: no-repeat;
    background: url('../../../../static/images/public/left-big.png') 0% center
        no-repeat,
      url('../../../../static/images/public/right-big.png') 100% center
        no-repeat;
    background-size: auto 100%, auto 100%;
    margin-bottom: 40px;
  }
  .basic-data-list {
    color: $c-white;
    > li {
      line-height: 1;
      margin-bottom: 40px;
    }
    .head-portrait {
      line-height: 70px;
      margin-bottom: 32px;
    }
  }

  .head-img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border: 1px solid $c-white;
    // background-size: cover;
    // background-repeat: no-repeat;
    // background-image: url('../../../../static/images/public/head-img.png');
  }
}
// .basic-data {
//   form {
//     width: 314px;
//     margin: 30px 0 60px;
//   }
// }
</style>
